/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FieldTypeEnumResponse {
    BOOLEAN = 'Boolean',
    STRING = 'String',
    TEXT = 'Text',
    INTEGER = 'Integer',
    DOUBLE = 'Double',
    DATE = 'Date',
    POSITION = 'Position',
    IMAGE = 'Image',
    OPTIONS = 'Options',
    MULTIPLE_OPTIONS = 'MultipleOptions',
    KEY_VALUE_PAIR_STRING_INT = 'KeyValuePairStringInt',
    ARRAY_OF_INT = 'ArrayOfInt',
    ARRAY_OF_DOUBLE = 'ArrayOfDouble',
    MANUAL_AREA = 'ManualArea',
    DEDUCTIONS = 'Deductions',
}